var exports = {
  "Z": "x1cb7f6e3--c03a86--layout",
};

module.exports = exports;
